/**
 * @generated SignedSource<<03f6a14f0601846fec747f8aaf27a569>>
 * @relayHash 911e121fe784c925bbce3b780cefb585
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5f285376005cd90c74efc7483ead8ba53771c0511d3184e208894c6c048036c3

import type { ConcreteRequest, Query } from 'relay-runtime';
export type PaidFeatureAwarenessRendererComponentQuery$variables = {
  cloudId: string;
};
export type PaidFeatureAwarenessRendererComponentQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly transactionAccounts: ReadonlyArray<{
      readonly isBillToPresent: boolean | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
};
export type PaidFeatureAwarenessRendererComponentQuery = {
  response: PaidFeatureAwarenessRendererComponentQuery$data;
  variables: PaidFeatureAwarenessRendererComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "isBillToPresent"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PaidFeatureAwarenessRendererComponentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "transactionAccounts",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaidFeatureAwarenessRendererComponentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "transactionAccounts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5f285376005cd90c74efc7483ead8ba53771c0511d3184e208894c6c048036c3",
    "metadata": {},
    "name": "PaidFeatureAwarenessRendererComponentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "42debe8c6363caadc4350f9048f2d4ef";

export default node;
